var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- Product thumbnail scroll progress ---------- */
(function(){
  var thumbs = document.querySelector('.pdp-thumbs');
  var progress = document.getElementById('pdpThumbsProgress');
  if (!thumbs || !progress) return;
  var fill = progress.querySelector('.pdp-thumbs-progress-fill');

  function update(){
    var scrollable = thumbs.scrollWidth - thumbs.clientWidth;
    if (scrollable <= 0){ progress.style.display = 'none'; return; }
    progress.style.display = '';
    var trackWidth = progress.clientWidth;
    var fillWidthPx = Math.max(24, (thumbs.clientWidth / thumbs.scrollWidth) * trackWidth);
    var maxLeft = trackWidth - fillWidthPx;
    var leftPx = (thumbs.scrollLeft / scrollable) * maxLeft;
    fill.style.width = fillWidthPx + 'px';
    fill.style.left = leftPx + 'px';
  }

  thumbs.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* ---------- Before / after slider ---------- */
(function(){
  var sliders = document.querySelectorAll('[data-ba-slider]');
  if (!sliders.length) return;

  sliders.forEach(function(slider){
    var before = slider.querySelector('[data-ba-before]');
    var handle = slider.querySelector('[data-ba-handle]');
    if (!before || !handle) return;
    var dragging = false;

    function setPct(pct){
      pct = Math.max(0, Math.min(100, pct));
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function pctFromEvent(e){
      var rect = slider.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    function startDrag(e){
      dragging = true;
      slider.classList.add('is-dragging');
      if (e.type === 'pointerdown' && handle.setPointerCapture) {
        try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      }
      setPct(pctFromEvent(e));
      e.preventDefault();
    }
    function moveDrag(e){
      if (!dragging) return;
      setPct(pctFromEvent(e));
    }
    function endDrag(){
      dragging = false;
      slider.classList.remove('is-dragging');
    }

    handle.addEventListener('pointerdown', startDrag);
    slider.addEventListener('pointerdown', startDrag);
    window.addEventListener('pointermove', moveDrag);
    window.addEventListener('pointerup', endDrag);

    handle.addEventListener('keydown', function(e){
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft'){ setPct(current - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight'){ setPct(current + 5); e.preventDefault(); }
    });
  });
})();

/* ---------- Product finder quiz ---------- */
(function(){
  var quiz = document.getElementById('pfQuiz');
  if (!quiz) return;
  var dataEl = document.getElementById('pfCatalogData');
  var catalog = {};
  try { catalog = JSON.parse(dataEl.textContent); } catch (e) { catalog = {}; }

  var progressBar = document.getElementById('pfProgressBar');
  var steps = quiz.querySelectorAll('.pf-step');
  var resultsEl = document.getElementById('pfResults');
  var selectedCategory = null;

  function goToStep(n) {
    steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === String(n)); });
    progressBar.style.width = (n / 3 * 100) + '%';
  }

  function buildResultCard(item) {
    var a = document.createElement('a');
    a.className = 'pf-result-card';
    a.href = item.url;

    var img = document.createElement('img');
    img.src = item.image;
    img.alt = item.title;
    img.width = 200;
    img.height = 200;
    img.loading = 'lazy';
    a.appendChild(img);

    var info = document.createElement('div');
    var title = document.createElement('strong');
    title.textContent = item.title;
    var price = document.createElement('span');
    price.textContent = '$' + Math.round(item.priceNum);
    info.appendChild(title);
    info.appendChild(price);
    a.appendChild(info);

    var cta = document.createElement('span');
    cta.className = 'btn btn-primary';
    cta.textContent = 'Shop now';
    a.appendChild(cta);

    return a;
  }

  function showResults(category, min, max) {
    resultsEl.innerHTML = '';
    var items = (catalog[category] || []).map(function (item) {
      return Object.assign({}, item, { priceNum: parseFloat(item.price) });
    });
    if (!items.length) {
      var p = document.createElement('p');
      p.className = 'muted';
      p.textContent = 'No matches right now — browse the full shop.';
      resultsEl.appendChild(p);
      return;
    }

    var inRange = items.filter(function (i) { return i.priceNum >= min && i.priceNum <= max; });
    var picks;
    if (inRange.length) {
      picks = inRange.slice(0, 2);
    } else {
      items.sort(function (a, b) {
        var da = Math.min(Math.abs(a.priceNum - min), Math.abs(a.priceNum - max));
        var db = Math.min(Math.abs(b.priceNum - min), Math.abs(b.priceNum - max));
        return da - db;
      });
      picks = items.slice(0, 1);
    }
    picks.forEach(function (item) { resultsEl.appendChild(buildResultCard(item)); });
  }

  quiz.querySelectorAll('[data-category]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedCategory = btn.dataset.category;
      goToStep(2);
    });
  });

  var backBtn = document.getElementById('pfBack');
  if (backBtn) backBtn.addEventListener('click', function () { goToStep(1); });

  quiz.querySelectorAll('[data-budget-min]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var min = parseFloat(btn.dataset.budgetMin);
      var max = parseFloat(btn.dataset.budgetMax);
      showResults(selectedCategory, min, max);
      goToStep(3);
    });
  });

  var restartBtn = document.getElementById('pfRestart');
  if (restartBtn) restartBtn.addEventListener('click', function () {
    selectedCategory = null;
    goToStep(1);
  });
})();

/* ---------- Mobile nav ---------- */
(function(){
  var navToggle = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');
  if(!navToggle || !mobileNav) return;
  navToggle.addEventListener('click', function(){
    var isOpen = mobileNav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  mobileNav.querySelectorAll('a').forEach(function(link){
    link.addEventListener('click', function(){
      mobileNav.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ---------- Accordion (FAQ + product tabs), height-animated ---------- */
function setFaqHeight(item){
  var answer = item.querySelector('.faq-a');
  if(!answer) return;
  answer.style.maxHeight = item.classList.contains('open') ? answer.scrollHeight + 'px' : '0px';
}
document.querySelectorAll('.faq-item').forEach(function(item){
  setFaqHeight(item);
  var q = item.querySelector('.faq-q');
  q.setAttribute('role', 'button');
  q.setAttribute('tabindex', '0');
  q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
  function toggle(){
    var wasOpen = item.classList.contains('open');
    var siblings = item.parentElement.querySelectorAll('.faq-item');
    siblings.forEach(function(s){
      s.classList.remove('open');
      setFaqHeight(s);
      s.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
    });
    if(!wasOpen){
      item.classList.add('open');
      setFaqHeight(item);
      q.setAttribute('aria-expanded', 'true');
    }
  }
  q.addEventListener('click', toggle);
  q.addEventListener('keydown', function(e){
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
  });
});
window.addEventListener('resize', function(){
  document.querySelectorAll('.faq-item.open').forEach(setFaqHeight);
});

/* ---------- Product reviews (show more) ---------- */
document.querySelectorAll('.review-more-btn').forEach(function(btn){
  var grid = btn.closest('.wrap').querySelector('.review-grid');
  if(!grid) return;
  btn.addEventListener('click', function(){
    var expanded = grid.classList.toggle('expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
  });
});

/* ---------- Gallery thumbs (product page) ---------- */
document.querySelectorAll('.pdp-thumb').forEach(function(t){
  t.setAttribute('role', 'button');
  t.setAttribute('tabindex', '0');
  if(!t.hasAttribute('aria-label')) t.setAttribute('aria-label', 'View product image');
  function selectThumb(){
    var group = t.parentElement;
    group.querySelectorAll('.pdp-thumb').forEach(function(o){ o.classList.remove('active'); });
    t.classList.add('active');
    var mainImage = document.getElementById('pdpMainImage');
    if(mainImage && t.dataset.image) mainImage.src = t.dataset.image;
  }
  t.addEventListener('click', selectThumb);
  t.addEventListener('keydown', function(e){
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); selectThumb(); }
  });
});

/* ---------- Real variant picker (product page) ---------- */
function formatMoney(cents){
  return '$' + (cents / 100).toFixed(2);
}

(function initVariantPicker(){
  var variantsScript = document.getElementById('ProductVariantsJson');
  var selectedScript = document.getElementById('ProductSelectedOptionsJson');
  if(!variantsScript || !selectedScript) return;

  var variants = JSON.parse(variantsScript.textContent);
  var selected = JSON.parse(selectedScript.textContent);

  var variantIdInput = document.getElementById('variantIdInput');
  var qtyInput = document.getElementById('qtyInput');
  var qtyDisplay = document.querySelector('#mainBuyRow .qty-value');
  var priceEl = document.getElementById('pdpPrice');
  var compareEl = document.getElementById('pdpCompare');
  var saveEl = document.getElementById('pdpSave');
  var addToCartBtn = document.getElementById('addToCartBtn');
  var stickyBtn = document.getElementById('stickyAddToCart');
  var stickyPrice = document.getElementById('stickyAtcPrice');
  var unavailableMsg = document.getElementById('variantUnavailable');
  var mainImage = document.getElementById('pdpMainImage');

  function findMatchingVariant(){
    var match = null;
    variants.forEach(function(v){
      if(match) return;
      var opts = [v.option1, v.option2, v.option3];
      var isMatch = opts.every(function(opt, i){
        return opt === null || opt === undefined || opt === selected[i];
      });
      if(isMatch) match = v;
    });
    return match;
  }

  function currentQty(){
    return parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
  }

  function updateForVariant(variant){
    if(!variant){
      if(unavailableMsg) unavailableMsg.style.display = 'block';
      if(addToCartBtn){ addToCartBtn.disabled = true; addToCartBtn.textContent = 'Unavailable'; }
      if(stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
      return;
    }
    if(unavailableMsg) unavailableMsg.style.display = 'none';
    if(variantIdInput) variantIdInput.value = variant.id;

    if(priceEl) priceEl.textContent = formatMoney(variant.price);
    if(stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if(variant.compare_at_price && variant.compare_at_price > variant.price){
      if(compareEl){ compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
      if(saveEl){
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saveEl.textContent = 'Save ' + pct + '%';
        saveEl.style.display = '';
      }
    } else {
      if(compareEl) compareEl.style.display = 'none';
      if(saveEl) saveEl.style.display = 'none';
    }

    if(variant.available){
      if(addToCartBtn){ addToCartBtn.disabled = false; addToCartBtn.textContent = 'Add to cart (' + formatMoney(variant.price * currentQty()) + ')'; }
      if(stickyBtn){ stickyBtn.disabled = false; stickyBtn.textContent = 'Add to cart'; }
    } else {
      if(addToCartBtn){ addToCartBtn.disabled = true; addToCartBtn.textContent = 'Sold out'; }
      if(stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Sold out'; }
    }

    if(mainImage && variant.featured_image && variant.featured_image.src){
      mainImage.src = variant.featured_image.src;
    }
  }

  document.querySelectorAll('.variant-options').forEach(function(group){
    var idx = parseInt(group.dataset.optionIndex, 10) - 1;
    group.querySelectorAll('.variant-pill').forEach(function(pill){
      pill.setAttribute('role', 'radio');
      pill.setAttribute('tabindex', '0');
      pill.setAttribute('aria-checked', pill.classList.contains('selected') ? 'true' : 'false');
      function choose(){
        group.querySelectorAll('.variant-pill').forEach(function(o){ o.classList.remove('selected'); o.setAttribute('aria-checked', 'false'); });
        pill.classList.add('selected');
        pill.setAttribute('aria-checked', 'true');
        selected[idx] = pill.dataset.value;
        updateForVariant(findMatchingVariant());
      }
      pill.addEventListener('click', choose);
      pill.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); choose(); }
      });
    });
  });

  document.querySelectorAll('#mainBuyRow .qty-stepper button').forEach(function(btn){
    btn.addEventListener('click', function(){
      var current = currentQty();
      if(btn.dataset.action === 'inc') current++;
      else if(current > 1) current--;
      if(qtyInput) qtyInput.value = current;
      if(qtyDisplay) qtyDisplay.textContent = current;
      updateForVariant(findMatchingVariant());
    });
  });
})();

/* ---------- Product add-on (bundle configuration) ---------- */
(function(){
  var form = document.getElementById('product-form');
  var addonCheckbox = document.querySelector('.addon-checkbox');
  if(!form || !addonCheckbox) return;
  form.addEventListener('submit', function(e){
    if(!addonCheckbox.checked) return;
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    var stickyBtn = document.getElementById('stickyAddToCart');
    [submitBtn, stickyBtn].forEach(function(b){ if(b) b.disabled = true; });
    var formData = new FormData(form);
    var items = [{
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity'), 10) || 1
    }, {
      id: parseInt(addonCheckbox.dataset.variantId, 10),
      quantity: 1
    }];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(res){
      if(!res.ok) throw new Error('cart add failed');
      window.location.href = form.querySelector('[name="return_to"]').value || '/cart';
    }).catch(function(){
      [submitBtn, stickyBtn].forEach(function(b){ if(b) b.disabled = false; });
      addonCheckbox.checked = false;
      form.submit();
    });
  });
})();

/* ---------- Discount popup ---------- */
(function(){
  var popup = document.getElementById('discountPopup');
  if(!popup) return;

  var STORAGE_KEY = 'revivalDiscountPopupSeen';
  var delay = parseInt(popup.dataset.delay, 10) || 5000;
  var posted = popup.dataset.posted === 'true';
  var card = popup.querySelector('.discount-popup-card');

  function openPopup(){
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch(e){}
  }

  var alreadySeen = false;
  try { alreadySeen = localStorage.getItem(STORAGE_KEY) === '1'; } catch(e){}

  if(posted){
    openPopup();
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch(e){}
  } else if(!alreadySeen){
    setTimeout(openPopup, delay);
  }

  card.querySelectorAll('.discount-popup-close, .discount-popup-dismiss').forEach(function(btn){
    btn.addEventListener('click', closePopup);
  });
  popup.querySelector('.discount-popup-backdrop').addEventListener('click', closePopup);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });
})();

/* ---------- Review detail modal (click a review card to see it in full) ---------- */
(function(){
  var cards = document.querySelectorAll('.review-card');
  if(!cards.length) return;

  var lightbox = document.createElement('div');
  lightbox.className = 'review-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.innerHTML =
    '<div class="review-lightbox-backdrop"></div>' +
    '<div class="review-lightbox-card">' +
      '<button type="button" class="review-lightbox-close" aria-label="Close">&times;</button>' +
      '<div class="review-lightbox-photos"></div>' +
      '<div class="review-lightbox-stars stars"></div>' +
      '<p class="review-lightbox-quote"></p>' +
      '<div class="testi-who">' +
        '<div class="avatar"></div>' +
        '<div><strong class="review-lightbox-name"></strong><span class="review-lightbox-role"></span></div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(lightbox);

  var backdrop = lightbox.querySelector('.review-lightbox-backdrop');
  var closeBtn = lightbox.querySelector('.review-lightbox-close');
  var photosEl = lightbox.querySelector('.review-lightbox-photos');
  var starsEl = lightbox.querySelector('.review-lightbox-stars');
  var quoteEl = lightbox.querySelector('.review-lightbox-quote');
  var nameEl = lightbox.querySelector('.review-lightbox-name');
  var roleEl = lightbox.querySelector('.review-lightbox-role');
  var lastFocused = null;

  function openFromCard(card){
    var photos = card.querySelectorAll('.review-photo');
    photosEl.innerHTML = '';
    photosEl.style.display = photos.length ? '' : 'none';
    photos.forEach(function(img){
      var big = document.createElement('img');
      big.src = img.src;
      big.alt = 'Customer photo';
      photosEl.appendChild(big);
    });
    starsEl.innerHTML = card.querySelector('.stars').innerHTML;
    quoteEl.textContent = card.querySelector('p').textContent;
    nameEl.textContent = card.querySelector('.testi-who strong').textContent;
    roleEl.textContent = card.querySelector('.testi-who span').textContent;

    lastFocused = document.activeElement;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeLightbox(){
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if(lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  cards.forEach(function(card){
    card.addEventListener('click', function(){ openFromCard(card); });
    card.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openFromCard(card); }
    });
  });
  backdrop.addEventListener('click', closeLightbox);
  closeBtn.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });
})();

/* ---------- Cart page quantity steppers ---------- */
document.querySelectorAll('.cart-line .qty-stepper button').forEach(function(btn){
  btn.addEventListener('click', function(){
    var input = btn.parentElement.querySelector('.qty-value-input');
    if(!input) return;
    var current = parseInt(input.value, 10) || 0;
    if(btn.dataset.action === 'inc') current++;
    else if(current > 0) current--;
    input.value = current;
  });
});

/* ---------- Scroll reveal ---------- */
var revealEls = document.querySelectorAll('.reveal');
if(prefersReducedMotion || !('IntersectionObserver' in window)){
  revealEls.forEach(function(el){ el.classList.add('in'); });
} else {
  var order = 0;
  var revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        var el = entry.target;
        el.style.transitionDelay = (order % 5) * 70 + 'ms';
        order++;
        el.classList.add('in');
        revealObserver.unobserve(el);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  revealEls.forEach(function(el){ revealObserver.observe(el); });

  // Safety net: never leave content permanently invisible if an element's
  // intersection callback is missed or delayed for any reason.
  setTimeout(function(){
    revealEls.forEach(function(el){ el.classList.add('in'); });
  }, 3000);
}

/* ---------- Count-up numbers ---------- */
function animateCount(el){
  var target = parseInt(el.dataset.target, 10) || 0;
  var duration = 1400;
  var start = null;
  function step(ts){
    if(start === null) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(eased * target).toLocaleString();
    if(progress < 1) requestAnimationFrame(step);
    else el.textContent = target.toLocaleString();
  }
  requestAnimationFrame(step);
}
var countEls = document.querySelectorAll('.count');
if(countEls.length){
  if(prefersReducedMotion || !('IntersectionObserver' in window)){
    countEls.forEach(function(el){ el.textContent = (parseInt(el.dataset.target,10)||0).toLocaleString(); });
  } else {
    var countObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          animateCount(entry.target);
          countObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });
    countEls.forEach(function(el){ countObserver.observe(el); });
  }
}

/* ---------- Sticky add-to-cart bar (product page) ---------- */
var mainBuyRow = document.getElementById('mainBuyRow');
var stickyAtc = document.getElementById('stickyAtc');
if(mainBuyRow && stickyAtc){
  var buyRowObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      stickyAtc.classList.toggle('show', scrolledPast);
    });
  }, { threshold: 0 });
  buyRowObserver.observe(mainBuyRow);
}

/* ---------- Scroll progress bar ---------- */
(function(){
  var bar = document.getElementById('scrollProgress');
  if(!bar) return;
  function update(){
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
    bar.style.width = pct + '%';
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* ---------- Tilt-hover cards ---------- */
if(!prefersReducedMotion && window.matchMedia('(pointer: fine)').matches){
  document.querySelectorAll('.benefit-card, .wave-card, .box-item, .testi-card, .ritual-card').forEach(function(card){
    card.addEventListener('mouseenter', function(){ card.classList.add('tilting'); });
    card.addEventListener('mousemove', function(e){
      var rect = card.getBoundingClientRect();
      var relX = (e.clientX - rect.left) / rect.width - 0.5;
      var relY = (e.clientY - rect.top) / rect.height - 0.5;
      var rotateY = relX * 10;
      var rotateX = relY * -10;
      card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function(){
      card.classList.remove('tilting');
      card.style.transform = '';
    });
  });
}

/* ---------- Inside the panel hotspots ---------- */
(function(){
  var wrap = document.querySelector('.hotspot-wrap');
  var dots = document.querySelectorAll('.hotspot-dot');
  if(!wrap || !dots.length) return;
  var panels = document.querySelectorAll('.hotspot-panel');
  var device = document.querySelector('.hotspot-device');
  var deviceImg = device ? device.querySelector('img') : null;
  var connectorPath = document.querySelector('.hotspot-connector path');
  var autoTimer = null;
  var userInteracted = false;
  var currentImage = deviceImg ? deviceImg.getAttribute('src') : null;

  /* preload every angle shot so switching is instant */
  dots.forEach(function(dot){
    var src = dot.getAttribute('data-image');
    if(src){ var pre = new Image(); pre.src = src; }
  });

  function drawConnector(dot){
    if(!connectorPath) return;
    var activePanel = document.querySelector('.hotspot-panel.active .hotspot-panel-num') ||
                       document.querySelector('.hotspot-panel.active');
    if(!activePanel){ connectorPath.classList.remove('drawn'); return; }
    var wrapRect = wrap.getBoundingClientRect();
    var dotRect = dot.getBoundingClientRect();
    var targetRect = activePanel.getBoundingClientRect();
    var x1 = dotRect.left + dotRect.width / 2 - wrapRect.left;
    var y1 = dotRect.top + dotRect.height / 2 - wrapRect.top;
    var x2 = targetRect.left + targetRect.width / 2 - wrapRect.left;
    var y2 = targetRect.top + targetRect.height / 2 - wrapRect.top;
    var midX = (x1 + x2) / 2;
    connectorPath.setAttribute('d', 'M ' + x1 + ' ' + y1 + ' C ' + midX + ' ' + y1 + ', ' + midX + ' ' + y2 + ', ' + x2 + ' ' + y2);
    connectorPath.classList.remove('drawn');
    /* force reflow so the draw-on transition restarts each time */
    connectorPath.getBoundingClientRect();
    requestAnimationFrame(function(){ connectorPath.classList.add('drawn'); });
  }

  function activate(i){
    var dot = document.querySelector('.hotspot-dot[data-index="' + i + '"]');
    var panel = document.querySelector('.hotspot-panel[data-index="' + i + '"]');
    if(!dot || !panel) return;
    dots.forEach(function(d){ d.classList.remove('active'); });
    panels.forEach(function(p){ p.classList.remove('active'); });
    dot.classList.add('active');
    panel.classList.add('active');

    var nextImage = dot.getAttribute('data-image');
    if(deviceImg && nextImage && nextImage !== currentImage){
      currentImage = nextImage;
      if(prefersReducedMotion){
        deviceImg.src = nextImage;
      } else {
        deviceImg.classList.remove('pop');
        deviceImg.style.opacity = '0';
        window.setTimeout(function(){
          deviceImg.src = nextImage;
          deviceImg.style.opacity = '1';
          /* force reflow so the pop animation restarts each time */
          deviceImg.getBoundingClientRect();
          deviceImg.classList.add('pop');
        }, 220);
      }
    }
    if(!prefersReducedMotion) drawConnector(dot);
  }

  dots.forEach(function(dot){
    dot.addEventListener('click', function(){
      userInteracted = true;
      if(autoTimer){ clearInterval(autoTimer); autoTimer = null; }
      activate(dot.dataset.index);
    });
  });

  window.addEventListener('resize', function(){
    var activeDot = document.querySelector('.hotspot-dot.active');
    if(activeDot && !prefersReducedMotion) drawConnector(activeDot);
  });

  if(!prefersReducedMotion && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && !userInteracted && !autoTimer){
          autoTimer = setInterval(function(){
            var current = document.querySelector('.hotspot-dot.active');
            var currentIndex = current ? parseInt(current.dataset.index, 10) : 0;
            var nextIndex = (currentIndex + 1) % dots.length;
            activate(nextIndex);
          }, 3500);
        }
      });
    }, { threshold: 0.5 });
    observer.observe(wrap);
  }
})();

/* ---------- Image zoom (product gallery) ---------- */
(function(){
  var zoomEl = document.querySelector('.zoom-container');
  if(!zoomEl || !window.matchMedia('(pointer: fine)').matches) return;
  var img = zoomEl.querySelector('img');
  if(!img) return;
  zoomEl.addEventListener('mousemove', function(e){
    var rect = zoomEl.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
    zoomEl.classList.add('zoomed');
  });
  zoomEl.addEventListener('mouseleave', function(){
    zoomEl.classList.remove('zoomed');
    img.style.transformOrigin = '';
  });
})();

/* ---------- Subtle cursor parallax on hero glow ---------- */
var heroSection = document.querySelector('.hero');
var heroGlow = document.querySelector('.hero-glow');
if(heroSection && heroGlow && !prefersReducedMotion && window.matchMedia('(pointer: fine)').matches){
  heroSection.addEventListener('mousemove', function(e){
    var rect = heroSection.getBoundingClientRect();
    var relX = (e.clientX - rect.left) / rect.width - 0.5;
    var relY = (e.clientY - rect.top) / rect.height - 0.5;
    heroGlow.style.translate = (relX * 40) + 'px ' + (relY * 40) + 'px';
  });
  heroSection.addEventListener('mouseleave', function(){
    heroGlow.style.translate = '0px 0px';
  });
}

/* ---------- Product carousel ---------- */
document.querySelectorAll('.shop-carousel-viewport').forEach(function(viewport){
  var track = viewport.querySelector('.shop-carousel-track');
  var wrap = viewport.closest('.wrap');
  var head = wrap ? wrap.querySelector('.carousel-head') : null;
  if(!track || !head) return;
  var prevBtn = head.querySelector('.carousel-prev');
  var nextBtn = head.querySelector('.carousel-next');

  function cardStep(){
    var card = track.querySelector('.shop-carousel-card');
    if(!card) return 260;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 20;
    return card.getBoundingClientRect().width + gap;
  }
  function updateArrows(){
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    if(prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
    if(nextBtn) nextBtn.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll;
  }
  if(prevBtn) prevBtn.addEventListener('click', function(){ track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
});

/* ---------- Video sequence (fast-cut clip cycling, no loop attribute so 'ended' fires) ---------- */
document.querySelectorAll('[data-video-sequence]').forEach(function(video){
  var clips = video.getAttribute('data-video-sequence').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  if(clips.length < 2) return;
  var i = 0;
  video.addEventListener('ended', function(){
    i = (i + 1) % clips.length;
    video.src = clips[i];
    video.play();
  });
});
